// removed by extract-text-webpack-plugin
module.exports = {"box":"styles__box___2K8BB"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/FixedVoice/components/Inputs/CardFixedVoice/styles.css
// module id = 3201
// module chunks = 0